import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const stats = [{
    value: '52',
    label: 'Bytových jednotek'
  }, {
    value: '2',
    label: 'Podzemní patra garáží'
  }, {
    value: 'A',
    label: 'Energetická třída'
  }, {
    value: '~60%',
    label: 'Měsíční náklady vs. standard'
  }];
  return <section id="o-projektu" className="py-24 bg-base-cream" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-16">
            <h2 className="font-heading text-4xl md:text-5xl text-primary mb-6" data-id="element-17">
              O projektu
            </h2>
            <div className="space-y-6 text-base-gray text-lg leading-relaxed" data-id="element-18">
              <p data-id="element-19">
                Polyfunkční{' '}
                <strong data-id="element-20">„Dům u Sv. Václava Dolní Jirčany/Psáry"</strong>{' '}
                vstupuje na trh v ČR s nejmodernějším systémovým řešením
                dokonalého prostoru pro bydlení a zdravý životní styl. Díky
                praktické aplikaci široké palety nejnovějších vědeckých poznatků
                v oblasti stavebních konstrukcí a využití maxima progresivních
                technologií 21. století přináší bezkonkurenční bydlení v
                komfortu, harmonii s přírodou, bezpečí, environmentální
                udržitelnosti, energetické efektivity, fyzické i psychické
                pohodě.
              </p>
              <p data-id="element-21">
                Konstrukce budovy je vytvořena s ohledem na splnění budoucích
                norem EU na minimalizaci uhlíkové stopy výstavby. Nosné
                konstrukce využívají kompozitní výztuž místo betonářské oceli,
                speciální betonové směsi garantují pružnost a pevnost, dokonalou
                prostupnost pro bezdrátové technologie a znemožňují tvorbu
                geopatogenních zón. Dřevo-hliníková okna s trojskly o tloušťce
                57 mm minimalizují tepelné ztráty, eliminují hlukovou zátěž a
                nejtenčím rámem ve své třídě zajišťují o 10 % více světla a až
                30% úsporu energií. Dům nevyužívá zemní plyn – vytápění
                zajišťují tepelná čerpadla a uhlíkové fólie s energetickou
                třídou A.
              </p>
              <p data-id="element-22">
                Plošné řešení bytů nabízí jako první v ČR optimální poměr
                vnitřního a vnějšího životního prostoru – byt, terasa, případně
                předzahrádka – namísto standardně nabízených „bytových kobek" s
                minimálním balkonem. Racionální architektonické členění se
                širokou variabilitou tvorby účelových zón dle individuálních
                požadavků každého klienta. Byty této koncepce garantují vysokou
                cenovou stabilitu a jejich hodnota bude v konkurenci se
                zastaralými typy rychleji narůstat.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-23">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl" data-id="element-24">
              <img src="https://cdn.magicpatterns.com/uploads/39KQJnk7h7vyeYhmKC3uMY/1.png" alt="Pohled na projekt Svatý Václav" className="w-full h-full object-cover" data-id="element-25" />
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-primary/10 rounded-full -z-10 blur-2xl" data-id="element-26"></div>
            <div className="absolute -top-6 -right-6 w-40 h-40 bg-accent/10 rounded-full -z-10 blur-2xl" data-id="element-27"></div>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-primary/10 pt-16" data-id="element-28">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="text-center" data-id="element-29">
              <div className="font-heading text-5xl md:text-6xl text-accent mb-3" data-id="element-30">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-base-dark font-medium uppercase tracking-wider" data-id="element-31">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}